import React from 'react';
import { FadeIn, Section, Button } from '../ui/Shared';
export const BonusesSection = () => {
  const bonuses = [{
    num: '1',
    title: 'Depresión Postparto y Lactancia',
    desc: 'Entendé la conexión entre la lactancia y tu estado emocional. Herramientas específicas para mamás que amamantan y atraviesan el postparto.'
  }, {
    num: '2',
    title: 'Cómo Volver a Sentirte Mujer, No Solo Madre',
    desc: 'Tu identidad no terminó el día que nació tu bebé. Esta guía te ayuda a reconectar con la mujer que sos — más allá de la maternidad.'
  }, {
    num: '3',
    title: 'Plan Preventivo para Futuro Embarazo',
    desc: 'Herramientas y estrategias para que, si decidís volver a ser mamá, estés emocionalmente preparada y sostenida desde el principio.'
  }, {
    num: '4',
    title: 'Recuperando el Sueño Emocional',
    desc: 'Un programa específico para reducir la ansiedad nocturna, calmar la mente y volver a descansar de verdad.'
  }];
  return <Section className="bg-gradient-to-b from-white to-pink-light/50" data-id="element-49" data-mp="32zmd77hxavek">
      <FadeIn className="text-center mb-10" data-id="element-50" data-mp="1gwupop6nlbzd">
        <h2 className="text-4xl md:text-5xl mb-3" data-id="element-51" data-mp="1by9x9bxn7wlh">
          🎁 Y además... 4 Bonos Exclusivos de Regalo
        </h2>
        <p className="text-xl italic text-brown-text/80" data-id="element-52" data-mp="16ynjn1dwkec5">
          Incluidos con tu compra hoy — sin costo adicional
        </p>
      </FadeIn>

      <div className="max-w-4xl mx-auto space-y-5" data-id="element-53" data-mp="11zu99htwx3g7">
        {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-54" data-mp="xzaa68ps3prf" data-mpi={i}>
            <div className="bg-white p-5 md:p-6 rounded-2xl border border-pink-border shadow-sm flex flex-col md:flex-row gap-5 items-start md:items-center" data-id="element-55" data-mp="t7s9zmvkxt7i">
              <div className="w-14 h-14 shrink-0 bg-pink-light rounded-full flex items-center justify-center text-2xl font-bold text-pink-deep font-heading border border-pink-border" data-id="element-56" data-mp="o978lk4ld3hh">
                {bonus.num}
              </div>
              <div className="flex-grow" data-id="element-57" data-mp="ecccf7vsjf6d">
                <h3 className="text-xl font-bold text-pink-deep mb-2 font-heading" data-id="element-58" data-mp="a8o3akrigbj0">
                  ✦ BONUS {bonus.num}: {bonus.title}
                </h3>
                <p className="text-brown-text/80 italic mb-3" data-id="element-59" data-mp="3vvjj5ucbb7ch">{bonus.desc}</p>
                <span className="inline-block bg-pink-primary/10 text-pink-deep text-sm font-bold px-3 py-1 rounded-full border border-pink-primary/20" data-id="element-60" data-mp="4o735in60zy5">
                  🎁 GRATIS CON TU COMPRA
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.5} className="text-center mt-8" data-id="element-61" data-mp="jcbm8nq4rdhg">
        <p className="italic text-brown-text/70" data-id="element-62" data-mp="nd57188a0c64">
          Todo incluido. Sin costos ocultos. Sin suscripciones. Tuyo para
          siempre.
        </p>
      </FadeIn>
    </Section>;
};
export const ValueStack = () => <Section className="bg-celeste-light" data-id="element-63" data-mp="eka2yhujomhx">
    <FadeIn data-id="element-64" data-mp="ej8saehfy20q">
      <h2 className="text-4xl md:text-5xl text-center mb-12 italic" data-id="element-65" data-mp="eiql4mt8q3e1">
        Todo lo que recibís hoy
      </h2>

      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-lg border border-celeste-primary/20 overflow-hidden" data-id="element-66" data-mp="171e2br548y9u">
        <div className="p-6 md:p-8" data-id="element-67" data-mp="1gfoacbynni5m">
          <div className="space-y-4" data-id="element-68" data-mp="1gemsnon4vxex">
            {[{
            icon: '📗',
            name: 'Tomo II — "Sanación Profunda"',
            val: '$24.950',
            status: 'Incluido'
          }, {
            icon: '🎁',
            name: 'Bonus 1 — Depresión Postparto y Lactancia',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 2 — Volver a Sentirte Mujer',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 3 — Plan Preventivo Futuro Embarazo',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '🎁',
            name: 'Bonus 4 — Recuperando el Sueño Emocional',
            val: '$9.990',
            status: 'Gratis'
          }, {
            icon: '📩',
            name: 'Entrega inmediata a tu correo',
            val: '—',
            status: 'Incluido'
          }, {
            icon: '♾️',
            name: 'Acceso de por vida al material',
            val: '—',
            status: 'Incluido'
          }].map((item, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-id="element-69" data-mp="sfnl8mryqddx" data-mpi={i}>
                <div className="flex items-center gap-3" data-id="element-70" data-mp="11e9at1vuqso7">
                  <span className="text-xl" data-id="element-71" data-mp="11fsqaq9oozox">{item.icon}</span>
                  <span className="font-medium text-sm md:text-base" data-id="element-72" data-mp="16du6n3fq6kwp">
                    {item.name}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm" data-id="element-73" data-mp="1bakl5mbvt8g0">
                  <span className="text-gray-400 line-through hidden md:inline" data-id="element-74" data-mp="1g46ryxvd6i3w">
                    {item.val}
                  </span>
                  <span className="text-green-600 font-bold bg-green-50 px-2 py-1 rounded" data-id="element-75" data-mp="1l4b82msd1atl">
                    ✅ {item.status}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-pink-light p-6 md:p-8 border-t border-pink-border flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-76" data-mp="3ekxrza8frf1g">
          <div className="text-center md:text-left" data-id="element-77" data-mp="39ktcnnj9kqct">
            <p className="text-gray-500 line-through mb-1" data-id="element-78" data-mp="35k9ecgmyfgp3">
              Valor total real: $89.860
            </p>
            <p className="text-2xl font-bold text-pink-deep font-heading" data-id="element-79" data-mp="30lppo8gz7qt1">
              🌸 Tu inversión hoy
            </p>
          </div>
          <div className="text-center md:text-right" data-id="element-80" data-mp="15jc4jv0vt75">
            <p className="text-4xl font-bold text-pink-deep" data-id="element-81" data-mp="3ta3lchkleb1f">$19.999 ARS</p>
            <p className="text-sm font-bold text-pink-primary mt-1 animate-pulse" data-id="element-82" data-mp="3tc7r7521xk4c">
              ¡OFERTA ACTIVA!
            </p>
          </div>
        </div>
      </div>
    </FadeIn>
  </Section>;
export const PricingCTA = () => <Section id="comprar" className="bg-white" data-id="element-83" data-mp="kts5gx8ay588">
    <FadeIn className="max-w-3xl mx-auto" data-id="element-84" data-mp="kvla66zcufdl">
      <div className="bg-white rounded-[2.5rem] shadow-2xl border border-pink-border p-6 md:p-10 text-center relative overflow-hidden" data-id="element-85" data-mp="g3lggw9voipg">
        {/* Decorative background blur */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gradient-to-b from-pink-light to-transparent opacity-50" data-id="element-86" data-mp="z1wq61j143tl"></div>

        <div className="relative z-10" data-id="element-87" data-mp="q81udk3srpqm">
          <h2 className="text-4xl md:text-5xl font-bold text-pink-deep mb-3 font-heading" data-id="element-88" data-mp="q709yp0w5qw8">
            🌸 Tu momento de renacer
          </h2>
          <p className="text-xl italic text-brown-text/80 mb-6" data-id="element-89" data-mp="g8jepfux6q4d">
            Solo por tiempo limitado
          </p>

          <div className="mb-6" data-id="element-90" data-mp="l9727rjxwotu">
            <p className="text-gray-400 line-through text-xl mb-2" data-id="element-91" data-mp="l9guxmwdda38">
              Antes: $49.900 ARS
            </p>
            <p className="text-6xl md:text-7xl font-bold text-pink-deep mb-3" data-id="element-92" data-mp="7aqym9hdjefx">
              $19.999 ARS
            </p>
            <p className="text-sm font-medium text-brown-text/70 bg-gray-50 inline-block px-4 py-2 rounded-full" data-id="element-93" data-mp="21mowxge5apx1">
              Pago único · Sin suscripción · Acceso inmediato
            </p>
          </div>

          <Button className="w-full md:w-auto text-xl py-6 px-12 mb-6 shadow-pink-primary/30" data-id="element-94" data-mp="3q5jmz4a0mxy2">
            〔 🌸 SÍ, QUIERO EMPEZAR MI RENACER 〕
          </Button>

          <div className="space-y-2 text-left max-w-md mx-auto mb-6 bg-pink-light/30 p-5 rounded-2xl" data-id="element-95" data-mp="3m2mxqupz03l5">
            <p className="flex items-center gap-2 font-medium" data-id="element-96" data-mp="3sbd59mb8ujr">
              <span className="text-green-500" data-id="element-97" data-mp="3v3l4hkrsmp7f">✓</span> Recibís todo en tu
              correo en minutos
            </p>
            <p className="flex items-center gap-2 font-medium" data-id="element-98" data-mp="dqr3vbhfe1sq">
              <span className="text-green-500" data-id="element-99" data-mp="8oiaie0n4xq3">✓</span> Acceso de por vida a los
              2 tomos + 4 bonos
            </p>
            <p className="flex items-center gap-2 font-medium" data-id="element-100" data-mp="moji0cbev3ej">
              <span className="text-green-500" data-id="element-101" data-mp="hrazgamcoxcr">✓</span> 7 días de garantía — sin
              preguntas
            </p>
          </div>

          <p className="text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-102" data-mp="2ogxwf1eqxpq7">
            <span data-id="element-103" data-mp="2jj5z1rvc1bem">🔒</span> Compra 100% segura · Pago protegido
          </p>
        </div>
      </div>
    </FadeIn>
  </Section>;